import IFramePanel from './view';

export default IFramePanel;
